import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { HtmlReactParser, HtmlReactParserOmitParagraphs, translate } from "@kaltura/mediaspace-shared-utils";
import { Truncate, generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface DescriptionProps {
    description: string;
}

const showMoreClassName = "kms-ds-media-page-description-show-more";

const StyledDescription = styled(Typography)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        marginTop: theme.spacing(3),
        maxWidth: 789,
        [`& .${showMoreClassName}`]: {
            textTransform: "capitalize",
        },
    },
]);

/**
 * media page metadata description
 */
export function Description(props: DescriptionProps) {
    const { description } = { ...props };

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = (isExpanded: boolean) => {
        const buttonType = isExpanded ? ButtonClickAnalyticsType.COLLAPSE : ButtonClickAnalyticsType.EXPAND;
        sendButtonAnalytics(`Media More info - ${isExpanded ? "Collapse" : "Expand"}`, buttonType);
    };

    return (
        <StyledDescription variant="body2" component="div" className="kms-ds-media-page-metadata-description">
            <Truncate
                lines={3}
                showMore={true}
                showMoreInNewLine={true}
                showMoreTranslatedText={translate("more info")}
                showLessTranslatedText={translate("less info")}
                toggleMoreClassName={showMoreClassName}
                onToggle={(isExpanded) => {
                    sendAnalytics(isExpanded);
                }}
                originalText={HtmlReactParser(description)}
            >
                {HtmlReactParserOmitParagraphs(description)}
            </Truncate>
        </StyledDescription>
    );
}

export default Description;
